import type { AuthState, AuthStep } from "./session";

/** What the shell knows once the server says there is no session. */
export function loggedOutState(): AuthState {
  return { authenticated: false, next: null, privacyNoticeVersion: null };
}

/** Keeps what GET /api/auth/state told us about the installation across step changes. */
function installationFacts(prev: AuthState | null): Omit<AuthState, "authenticated" | "next" | "rememberedUntil"> {
  return {
    privacyNoticeVersion: prev?.privacyNoticeVersion ?? null,
    privacyContact: prev?.privacyContact,
    sessionIdleMinutes: prev?.sessionIdleMinutes,
    rememberMeDays: prev?.rememberMeDays,
  };
}

/** The state after a login step answered `next` (DONE may carry the "Keep me signed in" end). */
export function stateAfterStep(prev: AuthState | null, next: AuthStep, rememberedUntil?: string | null): AuthState {
  return {
    authenticated: next !== null,
    next,
    ...installationFacts(prev),
    rememberedUntil: next === "DONE" ? (rememberedUntil ?? null) : null,
  };
}

/** The state after any call answered 401: the session is gone. */
export function stateAfterSessionLost(prev: AuthState | null): AuthState {
  return { authenticated: false, next: null, ...installationFacts(prev), rememberedUntil: null };
}

export function isSignedIn(state: AuthState | null): boolean {
  return state?.authenticated === true && state.next === "DONE";
}
